import { useMemo } from 'react'
import { useMyOrganizations } from './use-organization'
import { EARLY_ACCESS } from '../utils/constants'

export function useHostingEligibility() {
  const orgQuery = useMyOrganizations()

  const eligibleOrganizations = useMemo(
    () => orgQuery.organizations.filter((org) => org.isActive),
    [orgQuery.organizations],
  )
  const currentOrganization = eligibleOrganizations[0] ?? null

  return {
    ...orgQuery,
    eligibleOrganizations,
    currentOrganization,
    currentOrganizationId: currentOrganization?.id ?? null,
    canHost: EARLY_ACCESS.individualHostingEnabled || eligibleOrganizations.length > 0,
    canHostAsIndividual: EARLY_ACCESS.individualHostingEnabled,
  }
}
